var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditlogactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_12575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4876 11.9995L9.15426 2.66617C9.03797 2.46097 8.86933 2.29029 8.66555 2.17154C8.46176 2.0528 8.23012 1.99023 7.99426 1.99023C7.7584 1.99023 7.52677 2.0528 7.32298 2.17154C7.11919 2.29029 6.95055 2.46097 6.83426 2.66617L1.50093 11.9995C1.38338 12.2031 1.32175 12.4341 1.32227 12.6692C1.32279 12.9042 1.38545 13.135 1.50389 13.338C1.62234 13.5411 1.79236 13.7092 1.99673 13.8254C2.20109 13.9415 2.43253 14.0016 2.6676 13.9995H13.3343C13.5682 13.9993 13.7979 13.9375 14.0005 13.8204C14.203 13.7032 14.3711 13.5349 14.4879 13.3322C14.6048 13.1296 14.6663 12.8998 14.6662 12.6658C14.6662 12.4319 14.6046 12.2021 14.4876 11.9995Z",
    stroke: "#FF0400",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.66667",
    stroke: "#FF0400",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.334H8.00667",
    stroke: "#FF0400",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_12575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditlogactive);
export default __webpack_public_path__ + "static/media/auditlogactive.bf23d04c29a9f2fb2be5bd12c930d027.svg";
export { ForwardRef as ReactComponent };